import { render, staticRenderFns } from "./news-center.vue?vue&type=template&id=0de01f83&scoped=true&"
import script from "./news-center.vue?vue&type=script&lang=js&"
export * from "./news-center.vue?vue&type=script&lang=js&"
import style0 from "./news-center.vue?vue&type=style&index=0&id=0de01f83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de01f83",
  null
  
)

export default component.exports